import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'

import { SeFeCardModule } from 'se-fe-card'
import { SeHouseholdSetupFeatureWhosParticipatingModule } from '../lib/se-household-setup-feature-whos-participating.module'
import { WhoDocsComponent } from './who-docs/who-docs.component'
import { PROVIDERS } from './providers'

@NgModule({
  declarations: [WhoDocsComponent],
  exports: [WhoDocsComponent],
  imports: [
    CommonModule,
    SeFeCardModule,
    SeHouseholdSetupFeatureWhosParticipatingModule
  ],
  providers: PROVIDERS
})
export class SeHouseholdSetupFeatureWhosParticipatingDocsModule {}
